import React from "react";
import { Box } from "@mui/material";
import { C, TYPE } from "../../utils/designTokens";
import { ChoiceChip, RadioGroup, fieldSx, metaSx } from "./checkoutUi";

// The values every app, the backend and the receipts already read. A new one
// would print blank on the rider app and the restaurant's tickets.
export const DROPOFF_CHOICES = [
  { value: "LEAVE_AT_DOOR", label: "Leave at door" },
  { value: "HAND_IT_TO_ME", label: "Hand it to me" },
  { value: "MEET_AT_DOOR", label: "Meet at the door" },
];

/**
 * The end of step 1: how the driver hands the order over (delivery only) and
 * a note for whoever is making or bringing it.
 */
function DropoffAndNotes({ isPickUp, dropoffOption, setDropoffOption, instructions, setInstructions }) {
  return (
    <>
      {!isPickUp && (
        <Box sx={{ mt: 3 }}>
          <Box id="checkout-dropoff-label" sx={{ ...TYPE.subHeading, color: C.ink, mb: 1.25 }}>Drop-off</Box>
          <RadioGroup labelledBy="checkout-dropoff-label" sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {DROPOFF_CHOICES.map((choice) => (
              <ChoiceChip
                key={choice.value}
                checked={dropoffOption === choice.value}
                onSelect={() => setDropoffOption(choice.value)}
              >
                {choice.label}
              </ChoiceChip>
            ))}
          </RadioGroup>
        </Box>
      )}

      <Box sx={{ mt: 3 }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1.25 }}>
          <Box component="label" htmlFor="checkout-instructions" sx={{ ...TYPE.subHeading, color: C.ink }}>
            {isPickUp ? "Instructions for the restaurant" : "Instructions for the driver"}
          </Box>
          <Box component="span" sx={metaSx}>Optional</Box>
        </Box>
        <Box
          component="textarea"
          id="checkout-instructions"
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          placeholder={isPickUp ? "E.g. I'll wait outside, call when it's ready…" : "E.g. ring bell, gate code #1234, 2nd floor…"}
          rows={3}
          sx={{ ...fieldSx, display: "block", py: 1.25, lineHeight: 1.5, resize: "vertical" }}
        />
      </Box>
    </>
  );
}

export default React.memo(DropoffAndNotes);
